export default __webpack_public_path__ + "static/media/logo-rga.7be1853c.svg";